// src/services/logoutService.js
import { clearNotificationStorageForLogout } from "../notifications/storageKeys";

let apiBaseURL = "";
let uiHandler = null;
let isRunning = false;

export const setApiBaseURL = (url) => {
  apiBaseURL = url || "";
};

export const registerLogoutHandler = (fn) => {
  uiHandler = typeof fn === "function" ? fn : null;
};

/**
 * Envia logout ao servidor sem depender do axios/interceptors (evita loop).
 */
const serverBeaconLogout = async (reason) => {
  try {
    const token = localStorage.getItem("bearerToken");
    if (!token || !apiBaseURL) return;
    await fetch(`${apiBaseURL}/logout`, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ reason }),
    });
  } catch {
    /* silencioso */
  }
};

/**
 * Limpeza de storage 100% centralizada.
 */
const clearStorages = () => {
  try {
    let scope = "workspace";
    try {
      const rawUd = localStorage.getItem("userData");
      if (rawUd) {
        const u = JSON.parse(rawUd);
        if (u && typeof u.scope === "string") scope = u.scope;
      }
    } catch {
      /* ignore */
    }
    if (scope === "platform" || scope === "partner") {
      localStorage.removeItem("company");
      localStorage.removeItem("xproWorkspaceDatabase");
    }

    localStorage.removeItem("perm_scopes_cache");
    localStorage.removeItem("status");
    localStorage.removeItem("currentPage");
    localStorage.removeItem("bearerToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("lastActivity");
    localStorage.removeItem("tokenExpiration");
    localStorage.removeItem("productTable.columnWidths");
    localStorage.removeItem("productTable.visibleColumns");

    sessionStorage.removeItem("activeCompany");
    sessionStorage.removeItem("perm_scopes_cache");
    sessionStorage.removeItem("selectedCompanies");
    sessionStorage.removeItem("status");
    sessionStorage.setItem("firstLoad", true);
    sessionStorage.removeItem("workspace-config-cache");

    clearNotificationStorageForLogout();
  } catch {
    /* silencioso */
  }
};

/**
 * Logout unificado e idempotente.
 * @param {string} reason - ex: "manual" | "unauthorized" | "refresh_failed" | "inactivity"
 * @param {{redirect?: boolean}} opts
 */
export const unifiedLogout = async (reason = "manual", opts = { redirect: true }) => {
  if (isRunning) return;     // idempotente: evita múltiplas execuções simultâneas
  isRunning = true;

  try {
    await serverBeaconLogout(reason);
  } finally {
    let redirectTarget = "/login";
    try {
      const rawUd = localStorage.getItem("userData");
      if (rawUd) {
        const u = JSON.parse(rawUd);
        const scope = u?.scope;
        if (scope === "partner") redirectTarget = "/partner/login";
        if (scope === "platform") redirectTarget = "/platform/login";
      }
    } catch {
      /* ignore */
    }
    clearStorages();
    try {
      if (uiHandler) await uiHandler(); // limpa estados React (setters)
    } catch {
      /* silencioso */
    }
    if (opts?.redirect) {
      window.location.href = redirectTarget;
    }
    isRunning = false;
  }
};
